// Click par turant loader dikha do
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.btn-add-to-bag');
  if (!btn) return;

  // Sticky button skip karo — uska apna listener hai
  if (btn.classList.contains('sticky-add-to-cart')) return;

  // ✅ Personalization check — e.preventDefault se PEHLE
  const form = btn.closest('form');
  if (form) {
    const personInput = form.querySelector('.personalization-input');
    if (personInput && personInput.value.trim() === '') {
      personInput.focus();
      personInput.style.border = '2px solid red';
      personInput.placeholder = 'Please enter name first!';
      return;
    }
  }

  e.preventDefault();
  e.stopPropagation();

  btn.classList.add('loading');
  btn.disabled = true;

  const iconSrc = btn.dataset.iconSrc || '/assets/bag-icon.svg';
  const textEl = btn.querySelector('.btn-text');
  const formData = new FormData(form);

  fetch('/cart/add.js', { method: 'POST', body: formData })
    .then((r) => r.json())
    .then(() => {
      return Promise.all([
        fetch('/?sections=mini-cart').then((r) => r.json()),
        fetch('/cart.js').then((r) => r.json()),
      ]);
    })
    .then(([sectionData, cartData]) => {
      // Button restore
      btn.disabled = false;
      btn.classList.remove('loading');
      if (textEl) {
        textEl.innerHTML = `✔ Added`;
        setTimeout(() => {
          textEl.innerHTML = `<img src="${iconSrc}" alt=""> Add to bag`;
        }, 2000);
      }

      // Mini-cart update
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionData['mini-cart'], 'text/html');
      const newContent = doc.querySelector('#shopify-section-mini-cart');
      const currentContent = document.querySelector('#shopify-section-mini-cart');
      if (newContent && currentContent) {
        currentContent.innerHTML = newContent.innerHTML;
      }

      // Cart count badge
      const el = document.querySelector('[data-cart-count]');
      if (el && cartData.item_count > 0) {
        el.textContent = cartData.item_count;
        el.removeAttribute('hidden');
        el.classList.remove('bump');
        void el.offsetWidth;
        el.classList.add('bump');
      }

      // Cart drawer open
      document.querySelector('.custom-cart-drawer')?.classList.add('is-open');
      document.querySelector('.cart-drawer-overlay')?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('cart-open');

      document.dispatchEvent(new CustomEvent('cart:added'));
    })
    .catch((err) => {
      console.error('Cart error:', err);
      btn.disabled = false;
      btn.classList.remove('loading');
      if (textEl) {
        textEl.innerHTML = `<img src="${iconSrc}" alt=""> Add to bag`;
      }
      // Error par bhi sticky restore karo
      document.dispatchEvent(new CustomEvent('cart:added'));
    });
}, true);